import { render, staticRenderFns } from "./WowzaLivestreamRecordingForm.vue?vue&type=template&id=573330c0&scoped=true"
import script from "./WowzaLivestreamRecordingForm.vue?vue&type=script&lang=js"
export * from "./WowzaLivestreamRecordingForm.vue?vue&type=script&lang=js"
import style0 from "./WowzaLivestreamRecordingForm.vue?vue&type=style&index=0&id=573330c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573330c0",
  null
  
)

export default component.exports